<div class="sz-confirm-dialog" [class.is-open]="open()" [attr.aria-hidden]="!open()">
  <div class="sz-confirm-dialog__scrim" (click)="onScrimClick()"></div>
  <div class="sz-confirm-dialog__card" role="alertdialog" aria-modal="true">
    <div class="sz-confirm-dialog__header">{{ header() }}</div>
    @if (message()) {
      <div class="sz-confirm-dialog__message">{{ message() }}</div>
    }
    <div class="sz-confirm-dialog__actions">
      <sz-button variant="secondary" [fullWidth]="true" (click)="onCancel()">{{ cancelLabel() }}</sz-button>
      <sz-button [variant]="destructive() ? 'danger-ghost' : 'primary'" [fullWidth]="true" (click)="onConfirm()">
        {{ okLabel() }}
      </sz-button>
    </div>
  </div>
</div>
